import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Create a reservation (guest or user)
 */
export const createReservation = async (reservationData) => {
  try {
    const response = await axios.post(
      `${BASE_API}/reservations`,
      reservationData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating reservation:", error);
    throw error;
  }
};

/**
 * Create a reservation as logged-in user
 */
export const createReservationAsUser = async (reservationData) => {
  try {
    const response = await axios.post(
      `${BASE_API}/reservations/user`,
      reservationData,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating reservation as user:", error);
    throw error;
  }
};

/**
 * Get upcoming events for a restaurant
 */
export const getUpcomingEvents = async (restaurantId, limit = 10) => {
  try {
    const response = await axios.get(
      `${BASE_API}/reservations/restaurant/${restaurantId}/events`,
      { params: { limit } }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};

/**
 * Check table availability
 */
export const checkAvailability = async (restaurantId, date, time, tableId = null) => {
  try {
    const params = { date, time };
    if (tableId) params.tableId = tableId;

    const response = await axios.get(
      `${BASE_API}/reservations/restaurant/${restaurantId}/availability`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error checking availability:", error);
    throw error;
  }
};

/**
 * Get my reservations (authenticated)
 */
export const getMyReservations = async (filters = {}) => {
  try {
    const response = await axios.get(
      `${BASE_API}/reservations/my-reservations`,
      {
        headers: getAuthHeaders(),
        params: filters,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching reservations:", error);
    throw error;
  }
};

/**
 * Get reservation by ID
 */
export const getReservationById = async (id) => {
  try {
    const response = await axios.get(
      `${BASE_API}/reservations/${id}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching reservation:", error);
    throw error;
  }
};

/**
 * Update reservation
 */
export const updateReservation = async (id, updateData) => {
  try {
    const response = await axios.put(
      `${BASE_API}/reservations/${id}`,
      updateData,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating reservation:", error);
    throw error;
  }
};

/**
 * Cancel reservation
 */
export const cancelReservation = async (id) => {
  try {
    const response = await axios.delete(
      `${BASE_API}/reservations/${id}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error cancelling reservation:", error);
    throw error;
  }
};
